import { render, staticRenderFns } from "./DeleteSubdomainModal.vue?vue&type=template&id=22d068a0&"
import script from "./DeleteSubdomainModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSubdomainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22d068a0')) {
      api.createRecord('22d068a0', component.options)
    } else {
      api.reload('22d068a0', component.options)
    }
    module.hot.accept("./DeleteSubdomainModal.vue?vue&type=template&id=22d068a0&", function () {
      api.rerender('22d068a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/SubDomains/DeleteSubdomainModal.vue"
export default component.exports